export default class Stocktaking {
    static fromData(data) {
        if (!data) {
            return;
        }

        let stocktaking = new Stocktaking();
        stocktaking.header = data.header;
        stocktaking.values = data.values;

        Object.seal(stocktaking);
        return stocktaking;
    }
}
